/**
 @desc On touchstart event for the Body element.
 @private
 */
export default function () {
  this._tooltipClass.data([]).render();
}